
<div *ngIf="!isLoading() && mandatoryTrainingCollection()" class="mandatoryTraining">
  <app-slider-classic
    [collection]="mandatoryTrainingCollection()"
    [showViewMore]="false"
    [preview]="true"></app-slider-classic>
</div>
